import { type PreloadableAsset } from '@/composables/useAssetPreloader'
import type { ButtonFontTheme, ButtonTheme } from '@/types'
import { resolveAsset } from '@/utils/resolveAssets'

// Re-export from dedicated config files for backward compatibility
export type { ColorSlug, SectionName } from '@/config/colors.config'
export { CARD_GRADIENTS, FILTER_COLORS, SLUG_TO_SECTION } from '@/config/colors.config'
export { NEWS_GALLERY_CONFIG } from '@/config/news.config'
export { TOTEM_CARDS_CONFIG } from '@/config/totem.config'

export const MIN_LOADER_DURATION = 2000
export const LOADER_LERP_DURATION = 2.0

const videoAssets = import.meta.glob<{ default: string }>('@/assets/videos/*.mp4', { eager: true })
export const imageAssets = import.meta.glob<{ default: string }>('@/assets/img/**/*.{jpg,png}', { eager: true })

export const CRITICAL_ASSETS: PreloadableAsset[] = [
  { url: resolveAsset(videoAssets, 'bg-landing-section.mp4'), type: 'video' },
  { url: resolveAsset(imageAssets, 'bg-landing-section-map.jpg'), type: 'image' }
]

export const DEFAULT_BUTTON_THEME: ButtonTheme = 'permissions'

export const BUTTON_GRADIENTS: Record<ButtonTheme, string> = {
  permissions: 'linear-gradient(90deg, rgba(235, 235, 235, 0.4) 0%, rgba(255, 0, 51, 0.678) 20%, rgba(0, 148, 74, 0.733) 40%, rgba(255, 179, 0, 0.774) 60%, rgba(0, 130, 182, 0.736) 80%, rgba(235, 235, 235, 0.4) 100%)',
  modalDark: 'linear-gradient(90deg, rgba(235, 235, 235, 0.4) 0%, rgba(255, 0, 51, 0.678) 20%, rgba(0, 148, 74, 0.733) 40%, rgba(255, 179, 0, 0.774) 60%, rgba(0, 130, 182, 0.736) 80%, rgba(235, 235, 235, 0.4) 100%)',
  modalLight: 'linear-gradient(90deg, rgba(235, 235, 235, 0.4) 0%, rgba(255, 0, 51, 0.678) 20%, rgba(0, 148, 74, 0.733) 40%, rgba(255, 179, 0, 0.774) 60%, rgba(0, 130, 182, 0.736) 80%, rgba(235, 235, 235, 0.4) 100%)'
}

export const BUTTON_BACKGROUNDS: Record<ButtonTheme, string> = {
  permissions: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(240, 240, 240, 0.8) 50%, rgba(255, 255, 255, 0.9) 100%)',
  modalDark: 'linear-gradient(135deg, rgba(71, 71, 71, 0.74) 0%, rgba(0, 0, 0, 0.9) 100%)',
  modalLight: 'white'
}

export const BUTTON_FONT_COLORS: Record<ButtonTheme, ButtonFontTheme> = {
  permissions: 'dark',
  modalDark: 'light',
  modalLight: 'dark'
}
